<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 健康评估
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="体质(养生方案)">
								<el-select v-model="searchData.physiqueId" @change="changeTypePhysique"
									placeholder="请选择体质" filterable>
									<el-option value="">请选择</el-option>
									<el-option v-for="(item, index) in physiqueList" :key="index" :label="item.physique.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" label="性别">
								<el-select v-model="searchData.sex" @change="changeGender" placeholder="请选择性别">
									<el-option value="">请选择</el-option>
									<el-option v-for="(item, index) in sexList" :key="index" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" label="年龄段">
								<el-select v-model="searchData.ageId" @change="changeAge" placeholder="请选择年龄">
									<el-option value="">请选择</el-option>
									<el-option v-for="(item, index) in ageList.slice(0,3)" :key="index" :label="item.label"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="100">
							</el-table-column>
							<el-table-column align="center" label="养生方案" prop="healthPlan.name" width="200">
							</el-table-column>
							<el-table-column align="center" label="性别" prop="gender" width="200">
							</el-table-column>
							<el-table-column align="center" label="年龄段" prop="age.name" width="200">
							</el-table-column>
							<el-table-column align="center" label="常见症状">
								<template #default="{row}">
									<div v-if="row.symptoms && row.symptoms.length > 0">
										<span v-for="(item, index) in row.symptoms" :key="index">
											<span v-if="item.symptom">{{ item.symptom }}</span><span
												v-if="index != row.symptoms.length - 1">、</span>
										</span>
									</div>
									<div v-else>
										------
									</div>
								</template>
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange"
										:current-page="currentPage" layout="prev, pager, next, jumper"
										:total="total" :page-size="10"></el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增健康评估' : '编辑健康评估'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="120px">
						<div class="item">
							<div class="line">
								<el-form-item class="el-form-item-line" label="体质(养生方案)" prop="physiqueId">
									<el-select :disabled="addOrEdit == 'edit'" 
										v-model="addUserForm.physiqueId" placeholder="请选择体质" filterable>
										<el-option v-for="(item, index) in physiqueList" :key="index"
											:label="item.physique.name" :value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								
								<div style="display: inline-block;width:100%;">
									<el-form-item class="el-form-item-line" label="性别" prop="sex">
										<el-select :disabled="addOrEdit == 'edit'" @change="changeAddUserFormSex"
											v-model="addUserForm.sex" placeholder="请选择性别">
											<el-option v-for="(item, index) in sexList" :key="index" :label="item.label"
												:value="item.label">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item class="el-form-item-line" label="年龄段" prop="age">
										<el-select :disabled="addOrEdit == 'edit'" @change="changeAddUserFormAge"
											v-model="addUserForm.age" placeholder="请选择年龄">
											<el-option v-for="(item, index) in ageList.slice(0,3)" :key="index" :label="item.label"
												:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<el-form-item label="综述" prop="summarize">
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" class="longInput"
										v-model="addUserForm.summarize"></el-input>
								</el-form-item>
								<div class="dosageType" >
									<div class="dosage-con" v-for="(item, index) in addUserForm.symptoms" :key="index">
										<el-form-item label="常见症状" :prop="'symptoms.' + index + '.symptom'" :rules="{
											required: true,
											message: '常见症状不能为空',
											trigger: 'blur',
										  }">
											<el-input style="width: auto;" class="longInput" v-model="item.symptom">
											</el-input>
											
											<i style="width:20px;float: left;margin-top: 8px;" @click="addPillData()" class="dosageIcon el-icon-circle-plus">
												<CirclePlus></CirclePlus>
											</i>
											<i style="width:20px;float: left;margin-top: 8px;"  @click="deletePillData(index)" class="dosageIcon el-icon-remove" :style="
											  addUserForm.symptoms.length == 1 ? 'color:#ccc;' : ''
											">
												<Remove></Remove>
											</i>
										</el-form-item>
										<el-form-item label="症状描述" :prop="'symptoms.' + index + '.desc'" :rules="{
											required: true,
											message: '症状描述不能为空',
											trigger: 'blur',
										  }">
											<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
												class="longInput" v-model="item.desc"></el-input>
										</el-form-item>
										<el-form-item label="调理保养" :prop="'symptoms.' + index + '.desc'">
											<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
												class="longInput" v-model="item.maintenance"></el-input>
										</el-form-item>
									</div>
								</div>
								<el-form-item  label="图片" prop="pic">
									<el-autocomplete  popper-class="my-autocomplete" v-model="addUserForm.pic"
										:fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect">
										<template #prefix>
										    <el-icon class="el-input__icon"><Search></Search></el-icon>
										</template>
										<template #default="{item}">
											<div class="img">
												<img :src="globalImageUrl + item.path" />
												<span class="name">{{ item.name }}</span>
											</div>
										</template>
									</el-autocomplete>
									<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
								</el-form-item>
								<div class="select" v-if="selectedPicList.length > 0">
									<ul class="select-ul">
										<li v-for="(item, index) in selectedPicList" :key="index">
											<div class="path">
												<img :src="globalImageUrl + item.path" />
											</div>
											<span class="name">{{ item.name }}</span>
										</li>
									</ul>
									<ul class="selected-ul">
										<span class="span">已选择的图片：</span>
										<div class="li">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<span class="name">{{ item.name }}</span>
												<i @click="handleClose(item)" class="el-icon-circle-close">
													<CircleClose style="width:14px;float: left;margin-top: 8px;"></CircleClose>
												</i>
											</li>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	export default {
		data() {
			return {
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				changeTypeName: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
						name: "选项维护",
					},
					{
						id: 2,
						name: "健康评估",
					},
					{
						id: 3,
						name: "穴位维护",
					},
					{
						id: 4,
						name: "运动健康",
					},
					{
						id: 5,
						name: "药食管理",
					},
					{
						id: 6,
						name: "图片管理",
					},
					{
						id: 7,
						name: "视频管理",
					},
				],
				currentTabIndex: 3,
				searchData: {
					physiqueId: "", //体质id
					sex: "",
					ageId: "", //年龄段
				},
				fileData: null, //文件
				fileList: [],
				fileObj: null,
				tableListData: [],
				pulseList: [],
				addUserForm: {
					pic: "", //选择的图片
					physique: "", //体质
					physiqueId: "", //体制id
					summarize: "", //综述
					sex: "", //性别
					age: "", //年龄段
					ageId: "", //年龄段id
					healthAssessmentId: "", //健康评估id
					symptoms: [{
						symptom: "", //常见症状
						desc: "", //症状描述
						maintenance: '', //调理保养
					}, ],
				},

				rules: {
					physiqueId: [{
						required: true,
						message: "请选择体质",
						trigger: "change",
					}, ],
					
					sex: [{
						required: true,
						message: "请选择性别",
						trigger: "change",
					}, ],
					age: [{
						required: true,
						message: "请选择年龄段",
						trigger: "change",
					}, ],
				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				picList: [],
				selectedPicList: [], //被选中的图片
				isAcupointFlag: false, //是否为穴位
				isChineseMedicineFlag: false, //是否为中成药
				typeList: [{
						label: "中成药",
						id: "0",
					},
					{
						label: "膏方",
						id: "1",
					},
					{
						label: "颗粒剂",
						id: "2",
					},
					{
						label: "健康食品",
						id: "3",
					},
				],
				sexList: [{
						label: "男",
						id: "0",
					},
					{
						label: "女",
						id: "1",
					},
				],
				ageList: [],
				dosageTypeList: [{
						label: "丸",
						id: "0",
					},
					{
						label: "其他剂型",
						id: "1",
					},
				],
				videoList: [],
				selectVideoList: [],
				physiqueList: [], //体质列表
				physiqueName: "", //体质名字
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
				
			},
			//重置
			reset() {
				this.searchData = {
					physiqueId: "", //体质id
					sex: "",
					ageId: "", //年龄段
				}
				this.searchPluse();
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.physiqueName = "";
				this.addUserForm.pic = "";
				this.selectedPicList = []; //选择的图片
				this.addUserForm.physique = ""; //体质
				this.addUserForm.summarize = ""; //综述
				this.addUserForm.sex = ""; //性别
				this.addUserForm.age = ""; //年龄段
				this.addUserForm.ageId = "";
				this.addUserForm.physiqueId = "";
				this.addOrEdit = "add";
				this.addUserForm.symptoms = [{
					symptom: "", //常见症状
					desc: "", //症状描述
					maintenance:''
				}],
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//编辑健康评估
			edit(item) {
				this.addOrEdit = "edit";
				this.getHealthAssessmentDetail(item.id);
			},
			//获取健康评估详情
			getHealthAssessmentDetail(id) {
				this.$applicationJson("/business/base/healthAssessment/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.physiqueId  = item.healthPlanId;
							this.addUserForm.id = item.id;
							this.addUserForm.summarize = item.overview;
							this.addUserForm.sex = item.gender;
							this.addUserForm.age = item.age.name;
							this.addUserForm.ageId = item.age.id;							
							if(item.symptoms.length==0){
								this.addUserForm.symptoms = [{
									symptom:"", //常见症状
									desc:"", //症状描述
									maintenance:''
								}]
							}else{
								this.addUserForm.symptoms = item.symptoms;
							}
							if (item.images) {
								this.selectedPicList = item.images;
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
							this.addUserFlag = true;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除健康评估
			del(item) {
				let ids = [];
				ids.push(item.id);
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						this.$applicationJson("/business/base/healthAssessment/delete", {
								ids: ids,
							})
							.then((res) => {
								if (res.data.code == 0) {
									this.$message({
										type: "success",
										message: "删除成功!",
									});
								}
								this.getHealthAssessmentList(this.currentPage);
							})
							.catch((Error) => {
								this.$message.error("网络异常");
							});
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//确定
			addPatient(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add") {
							this.$nextTick(() => {
								this.addHealthAssessmentInfo();
							});
						}
						if (this.addOrEdit == "edit") {							
							this.$nextTick(() => {
								this.editHealthAssessment();
							});
						}
					} else {
						return false;
					}
				});
			},
			//获取年龄列表
			getAgeList() {
				this.$applicationJson("/business/base/age/list", {})
					.then((res) => {
						if (res.data.code == 0) {
							res.data.data.map((item, index) => {
								if (item.name && item.name != "全部") {
									this.ageList.push({
										label: item.name,
										id: item.id,
									});
									
								}
							});
							
							
						}
					})
					.catch(() => {
						this.$message.error("网络异常");
					});
			},
			//新增健康评估接口
			addHealthAssessmentInfo() {
				this.$applicationJson("/business/base/healthAssessment/add", {
						ageId: this.addUserForm.ageId,
						gender: this.addUserForm.sex,
						images: this.selectedPicList,
						overview: this.addUserForm.summarize,
						symptoms: this.addUserForm.symptoms,
						healthPlanId: this.addUserForm.physiqueId
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
							this.getHealthAssessmentList(this.currentPage);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getHealthAssessmentList(this.currentPage);
			},
			//编辑健康评估
			editHealthAssessment() {
				this.$applicationJson("/business/base/healthAssessment/edit", {
						ageId: this.addUserForm.ageId,
						gender: this.addUserForm.sex,
						images: this.selectedPicList,
						overview: this.addUserForm.summarize,
						symptoms: this.addUserForm.symptoms,
						healthPlanId: this.addUserForm.physiqueId,
						id: this.addUserForm.id
					})
					.then((res) => {
						// console.log("编辑", res);
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getHealthAssessmentList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//搜索
			searchPluse() {
				this.getHealthAssessmentList(0);
				this.currentPage = 0;
			},
			//获取健康评估列表
			getHealthAssessmentList(currentPage) {
				this.$applicationJson("/business/base/healthAssessment/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							healthPlanId: this.searchData.physiqueId,
							ageId: this.searchData.ageId,
							gender: this.searchData.sex,
						},
						size: 10,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},

			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			//视频关闭
			handleVideoClose(tag) {
				this.addUserForm.videoId = "";
				this.selectVideoList.splice(this.selectVideoList.indexOf(tag), 1);
			},
			//搜索切换体质搜索类型
			changeTypePhysique(val) {
				this.searchData.physiqueId = val;
				this.getHealthAssessmentList(0);
				this.currentPage = 0;
			},
			//搜索切换性别
			changeGender(val) {
				this.searchData.sex = val;
				this.getHealthAssessmentList(0);
				this.currentPage = 0;
			},
			//搜索切换年龄段
			changeAge(val) {
				this.searchData.ageId = val;
				this.getHealthAssessmentList(0);
				this.currentPage = 0;
			},
			//新增体质修改切换类型
			changeAddUserFormPhysique(val) {
				this.addUserForm.physiqueId = val;
				this.physiqueList.map((item, index) => {
					if (item.id == val) {
						this.physiqueName = item.label;
					}
				});
				this.addUserForm.pic = "";
				this.addUserForm.summarize = ""; //综述
				this.addUserForm.sex = ""; //性别
				this.addUserForm.age = ""; //年龄段
				this.addUserForm.ageId = ""; //年龄段
				this.addUserForm.symptoms.symptom = ""; //常见症状
				this.addUserForm.symptoms.desc = ""; //症状描述
				this.addUserForm.symptoms.maintenance = ""; //症状描述				
			},
			//新增性别修改切换类型
			changeAddUserFormSex(val) {
				this.addUserForm.sex = val;
			},
			//新增年龄段修改切换类型
			changeAddUserFormAge(val) {
				this.addUserForm.ageId = val;
			},
			//新常见症状数据
			addPillData() {
				if (this.addUserForm.symptoms == undefined) {
					this.addUserForm.symptoms = [];
				}
				let obj = {
					symptom: "", //常见症状
					desc: "", //症状描述
					maintenance:''
				};
				this.addUserForm.symptoms.push(obj);
			},
			//删除丸数据
			deletePillData(index) {
				if (this.addUserForm.symptoms.length > 1) {
					this.addUserForm.symptoms.splice(index, 1);
				}
			},
			
			//选择视频
			selectVideo(id) {
				this.selectVideoList = [];
				for (let i = 0; i < this.videoList.length; i++) {
					if (this.videoList[i].id == id) {
						this.selectVideoList.push(this.videoList[i]);
					}
				}
			},
			//获取视频列表
			getVideoList(page) {
				this.$applicationJson("/business/shutcm/video/paging", {
						orderBy: null,
						orderType: 1, //0正序  1倒序
						page: 0,
						pageSize: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.videoList = res.data.data.records;
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//获取体质列表
			getPhysiqueList() {
				this.$applicationJson("/business/baseHealthPlan/paging", {
					current: 0,
					orderBy: "",
					params: {	
					},
					size: 100,
				})
					.then((res) => {
						if (res.data.code == 0) {
							this.physiqueList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getImageList(0);
				this.getHealthAssessmentList(0);
				this.getVideoList();
				this.getPhysiqueList();
				this.getAgeList();
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 120px;
						@media screen and (min-width: 1605px) and (max-width: 1920px) {
							height: 60px;
							width: 100%;
						}
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 160px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}
		}
	}

	.dialog {
		:deep(.el-dialog__body){
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						.dosage-con {
							border: 1px dashed #999;
							padding: 10px;
							margin-bottom: 10px;
							float: left;
						}

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner){
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
